import { getResolvedWardsaveReduction } from './resolvedContext';

const toPercentEntries = (items = []) =>
  (Array.isArray(items) ? items : [])
    .map((item) => (typeof item === 'string' ? { type: item, percent: 50 } : item))
    .filter((item) => item?.type);

export const applyResolvedDamageMitigation = ({
  currentDamage = 0,
  damageType = '',
  target = {},
  isRaidwide = false,
  activeLegacyEffects = [],
  immuneSourceLabel = null,
  immuneValueFormatter = null,
} = {}) => {
  const resistances = toPercentEntries(target.resistances);
  const vulnerabilities = toPercentEntries(target.vulnerabilities);
  const immunities = Array.isArray(target.immunities) ? target.immunities : [];
  const breakdown = [];
  let damage = currentDamage;
  let modifier = 'normal';
  let percent = 0;

  if (immunities.includes(damageType)) {
    breakdown.push({
      source: immuneSourceLabel || `Immune (${damageType})`,
      type: 'immune',
      value: immuneValueFormatter ? immuneValueFormatter(damage) : '-100%',
      rawValue: -damage,
      resultingDamage: 0,
    });
    return { damage: 0, modifier: 'immune', percent: 100, breakdown };
  }

  if (isRaidwide && target.raidwideResist > 0) {
    const reduction = Math.floor(damage * (target.raidwideResist / 100));
    damage -= reduction;
    breakdown.push({
      source: 'Raid Resistance',
      type: 'raidResist',
      value: `-${target.raidwideResist}%`,
      rawValue: -reduction,
      resultingDamage: damage,
    });
    modifier = 'raidResist';
    percent = target.raidwideResist;
  }

  const vulnerability = modifier === 'raidResist'
    ? null
    : vulnerabilities.find((item) => item.type === damageType);
  if (vulnerability) {
    const increase = Math.floor(damage * (vulnerability.percent / 100));
    damage += increase;
    breakdown.push({
      source: `Vulnerable (${damageType})`,
      type: 'vulnerable',
      value: `+${vulnerability.percent}%`,
      rawValue: increase,
      resultingDamage: damage,
    });
    modifier = 'vulnerable';
    percent = vulnerability.percent;
  }

  const resistance = (modifier === 'raidResist' || modifier === 'vulnerable')
    ? null
    : resistances.find((item) => item.type === damageType);
  if (resistance) {
    const reduction = Math.floor(damage * (resistance.percent / 100));
    damage -= reduction;
    breakdown.push({
      source: `Resistant (${damageType})`,
      type: 'resistant',
      value: `-${resistance.percent}%`,
      rawValue: -reduction,
      resultingDamage: damage,
    });
    modifier = 'resistant';
    percent = resistance.percent;
  }

  const wardsave = getResolvedWardsaveReduction({
    currentDamage: damage,
    activeLegacyEffects,
  });
  if (wardsave.reduction > 0) {
    damage -= wardsave.reduction;
    breakdown.push({
      source: wardsave.sourceLabel,
      type: 'wardsave',
      value: `-${wardsave.total}%`,
      rawValue: -wardsave.reduction,
      resultingDamage: damage,
    });
  }

  return { damage, modifier, percent, breakdown };
};
